export default __webpack_public_path__ + "locales/nl/DeleteDialog.json?hash=00ee0ebd12acdf736f60efb7e49c9522";